var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-text-center tw-flex-shrink-0 tw-text-black tw-text-[11px] 2xl:tw-text-[14px] tw-py-[6px] tw-px-3 xl:tw-py-[2px] 2xl:tw-py-1 2xl:tw-px-4 tw-rounded-[24px]",style:(("background-color: " + (_vm.setColor(_vm.grade)) + ";"))},[_c('nobr',[_vm._v("\n    "+_vm._s(_vm.grade)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7acdc227","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partners/GradeItem.vue
// module id = null
// module chunks = 